import React from "react";
import { Box, Typography } from "@mui/material";

const getYouTubeEmbedUrl = (url) => {
  if (!url) return "";
  if (url.includes("/shorts/")) {
    const id = url.split("/shorts/")[1].split("?")[0];
    return `https://www.youtube.com/embed/${id}`;
  }
  if (url.includes("watch?v=")) {
    const id = url.split("watch?v=")[1].split("&")[0];
    return `https://www.youtube.com/embed/${id}`;
  }
  return url;
};

const truncateTitle = (title, limit = 30) => {
  if (!title) return "";
  return title.length > limit ? title.substring(0, limit) + "..." : title;
};

const VideoReels = ({ videoItems = [] }) => {
  if (!videoItems.length) return null;

  return (
    <Box sx={{ columnCount: { xs: 1, sm: 2, md: 3 }, columnGap: 0.6, padding: 1 }}>
      {videoItems.map((item, index) => {
        const mediaType = item.mediaType?.toLowerCase();

        const isYouTube = mediaType === "ytvideo";
        const isVimeo = mediaType === "vimvideo";
        const isEmbed = isYouTube || isVimeo;
        const isUploadedVideo = mediaType === "video";

        const isShort =
          isYouTube &&
          (item.mediaLink?.includes("/shorts/") ||
            item.mediaName?.includes("/shorts/"));

        const embedUrl = isYouTube
          ? getYouTubeEmbedUrl(item.mediaLink || item.mediaName)
          : isVimeo
          ? item.mediaLink || item.mediaName
          : null;

        const videoSrc = item.mediaName || "";
        const videoType = videoSrc.toLowerCase().endsWith(".webm")
          ? "video/webm"
          : "video/mp4";

        return (
          <Box key={item.mediaId || index} sx={{ breakInside: "avoid", mb: 1 }}>
            <Typography variant="subtitle2" gutterBottom>
              {truncateTitle(item.mediaTitle)}
            </Typography>

            <Box
              sx={{
                borderRadius: 1,
                overflow: "hidden",
                backgroundColor: "#000",
              }}
            >
              {isEmbed ? (
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    aspectRatio: isShort ? "9 / 16" : "16 / 9",
                  }}
                >
                  <iframe
                    src={embedUrl}
                    title={item.mediaTitle || `Video ${index + 1}`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                    allowFullScreen
                    style={{
                      position: "absolute",
                      inset: 0,
                      width: "100%",
                      height: "100%",
                      border: "none",
                    }}
                  />
                </Box>
              ) : isUploadedVideo ? (
                <video
                  controls
                  preload="metadata"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                    display: "block",
                    backgroundColor: "#000",
                  }}
                >
                  <source src={videoSrc} type={videoType} />
                </video>
              ) : null}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default VideoReels;